module.exports = __webpack_public_path__ + "media/images/lb/498-72af1cc1902be068a57ed4befd462e75.svg";